import { CommonModule, registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { CalculatorComponent } from "./calculator/calculator.component";
import { SocialHousingCalculatorRoutingModule } from "./routing/social-housing-calculator.routing.module";
import { FormUtilsService } from "./services/form-utils.service";
import { SocialHousingService } from "./services/social-housing.service";
import { SocialHousingCalculatorComponent } from "./social-housing-calculator.component";

import frCA from "@angular/common/locales/fr-CA";
import { ResultComponent } from "./calculator/result/result.component";
import { SearchLocationComponent } from "./calculator/search-location/search-location.component";
import { ErrorHandlerComponent } from "./error-handler/error-handler.component";
import { PrintLayoutComponent } from "./print-layout/print-layout.component";
import { PrintReportComponent } from "./print-report/print-report.component";
import { InterceptorService } from "./services/error-interceptor.service";
import { ErrorService } from "./services/errors.service";
import { PrintService } from "./services/print.service";

registerLocaleData(frCA);

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    SocialHousingCalculatorRoutingModule,
    HttpClientModule,
  ],
  declarations: [
    CalculatorComponent,
    SearchLocationComponent,
    ResultComponent,
    SocialHousingCalculatorComponent,
    ErrorHandlerComponent,
    PrintLayoutComponent,
    PrintReportComponent,
  ],
  providers: [
    FormUtilsService,
    SocialHousingService,
    PrintService,
    ErrorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: "fr-CA" },
  ],
})
export class SocialHousingCalculatorModule {}
